module.exports = "images/4ans.e0b919ef.png";